const namespace = '[Planner]';

export const PLANNER_SET = `${namespace} PLANNER SET`;
export const PLANNER_GET = `${namespace} PLANNER GET`;
export const PLANNER_UPDATE = `${namespace} PLANNER UPDATE`;
export const PLANNER_UPDATE_MULTIPLE = `${namespace} PLANNER UPDATE MULTIPLE`;
export const PLANNER_ADD_ASSIGNMENT = `${namespace} PLANNER ADD ASSIGNMENT`;
export const PLANNER_REMOVE = `${namespace} PLANNER REMOVE`;
export const PLANNER_MODIFY = `${namespace} PLANNER MODIFY`;
